export default {
  namespaced: true,

  state: {
    updated: false,
    created: false
  },

  getters: {
    getMemberUpdated(state) {
      return state.updated;
    },
    getMemberCreated(state) {
      return state.created;
    }
  },

  mutations: {
    SET_UPDATED(state, value) {
      state.updated = value;
    },
    SET_CREATED(state, value) {
      state.created = value;
    }
  },

  actions: {
    memberUpdated({ dispatch, commit }, value) {
      commit('SET_UPDATED', value);
    },

    memberCreated({ dispatch, commit }, value) {
      commit('SET_CREATED', value);
    }
  }
};
